import { createSelector } from 'reselect'
import userTypes from '../../../helpers/enums/userTypes'
import viewTypes from '../../../helpers/enums/views'
import gameStates from '../../../helpers/enums/gameStates'
import userTypeSelector from './userTypeSelector'
import userIdSelector from './userIdSelector'
import { IStore } from '../../reducers/index'

const gameSelector = (state: IStore) => state.game

export default createSelector(userTypeSelector, userIdSelector, gameSelector, (userType, userId, game) => {
	let userView = viewTypes.SPLASH

	if (userType === userTypes.TEACHER) {
		userView = game.currentView.type
	} else {
		const participant = game.participants.find((participant) => participant.deviceUid === userId)
		if (participant) {
			userView =
				[viewTypes.GAME, viewTypes.WINNERS].includes(participant.view.type) &&
				participant.view.payload &&
				participant.view.payload.state === gameStates.TRANSITIONING
					? viewTypes.GAME
					: participant.view.type
		}
	}

	return userView
})
